var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrowUpIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "16px",
    viewBox: "0 -960 960 960",
    width: "16px",
    fill: "#1f1f1f",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-80v-647L256-544l-56-56 280-280 280 280-56 57-184-184v647h-80Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowUpIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrowUpIcon.e44439ac.svg";
export { ForwardRef as ReactComponent };